import React from 'react';
import {
  appStoreURL,
  googlePlayURL,
  IconAppStore,
  IconGooglePlay,
} from '@noths/polaris-client-ribbons-design-system';

import type { Environment } from 'src/types/environment';
import { dggTheme } from '../../../../styles/dggTheme';
import { ButtonLink } from '../../atoms/ButtonLink/ButtonLink';
import { FooterSocialMedia } from '../FooterSocialMedia/FooterSocialMedia';
import { NewsletterSignUpForm } from '../NewsletterSignUpForm/NewsletterSignUpForm';
import * as styles from './Footer.styles';

interface FooterProps {
  env: Environment;
}

export const Footer = ({ env }: FooterProps) => {
  return (
    <div css={styles.root}>
      <div css={styles.content}>
        <h3 css={styles.heading}>Discover more Christmas</h3>
        <div css={styles.button}>
          <ButtonLink
            backgroundColor={dggTheme.colors.neutralWhite}
            href="/christmas"
            text="Shop now"
            textColorMode="dark"
          />
        </div>
        <NewsletterSignUpForm env={env} />
        <div css={styles.promo}>
          <div css={styles.group}>
            <h3 css={styles.heading}>Get the app</h3>
            <a css={styles.link} href={appStoreURL} title="App Store">
              <IconAppStore width="120" height="40" />
            </a>
            <a css={styles.link} href={googlePlayURL} title="Google Play">
              <IconGooglePlay width="135" height="40" />
            </a>
          </div>
          <div css={styles.group}>
            <h3 css={styles.heading}>Get social</h3>
            <FooterSocialMedia />
          </div>
        </div>
        <p css={styles.copyright}>Copyright 2006-2023</p>
        <p css={styles.copyright}> Notonthehighstreet Enterprises Limited</p>
      </div>
    </div>
  );
};
